import listStyles from '../list/list.module.scss';
import {VehicleLogo} from './vehicle_logo.tsx';
import {Spacer} from '../utility/spacer.tsx';
import {VehicleBrandModel, VehicleBrandModelSize} from './vehicle_brand_model.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {Identifier} from '../identifier/identifier.tsx';
import {ListItem} from '../list/list_item.tsx';
import {VehicleType} from '../../gql/customer/graphql.ts';
import React from 'react';
import {brandLogo} from '../../support/brand_logo.ts';

interface OwnProps {
    vehicle?: VehicleType | null;
    onClick?: () => void;
    button?: React.ReactNode;
}
export function VehicleListItem({vehicle, onClick, button}: OwnProps) {
    if (!vehicle) {
        return null;
    }
    const onItemClick = () => {
        if (onClick !== undefined) {
            onClick();
        }
    };
    return (
        <ListItem key={vehicle.id} onClick={() => onItemClick()}>
            <div className={listStyles.list__item_content}>
                <VehicleLogo alt={vehicle.model ?? ''} src={brandLogo(vehicle.brand)} />
                <Spacer />
                <VehicleBrandModel
                    brand={vehicle.brand ?? ''}
                    model={vehicle.model ?? ''}
                    size={VehicleBrandModelSize.Small}
                    alignment={Alignment.Start}
                />
            </div>
            <div className={listStyles.list__item_content}>
                <Identifier identifier={vehicle.identifiers?.find((id) => id?.type === 'license_plate')?.value ?? ''} />
                {button && <Spacer />}
                {button}
            </div>
        </ListItem>
    );
}
